module.exports = __webpack_public_path__ + "img/envelope-icon-grey.fdd79f95.svg";